// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayBills_main__x4FDh {
  display: grid;
  grid-template-columns: 1fr 3fr;
  column-gap: 3rem;
  margin-top: 5rem;
}
@media only screen and (max-width: 50em) {
  .PayBills_main__x4FDh {
    grid-template-columns: 100%;
    row-gap: 3rem;
  }
}

.PayBills_pb__Gc2-- {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.PayBills_pb__Gc2-- > :not(:last-child) {
  margin-bottom: 1rem;
}
@media only screen and (max-width: 50em) {
  .PayBills_pb__Gc2-- {
    flex-direction: row;
  }
}
.PayBills_pb__item__GIo4- {
  background-color: var(--color-primary-7);
  width: 100%;
  height: 17rem;
  border-radius: 2rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .PayBills_pb__item__GIo4- {
    width: 30%;
  }
}
@media only screen and (max-width: 37.5em) {
  .PayBills_pb__item__GIo4- {
    height: 12rem;
  }
}
@media only screen and (max-width: 25em) {
  .PayBills_pb__item__GIo4- {
    height: 10rem;
  }
}
.PayBills_pb__image__24Sfg {
  width: 6rem;
  margin-bottom: 1.5rem;
}
@media only screen and (max-width: 37.5em) {
  .PayBills_pb__image__24Sfg {
    width: 4rem;
  }
}
@media only screen and (max-width: 25em) {
  .PayBills_pb__image__24Sfg {
    width: 3rem;
  }
}

.PayBills_history__HkVcf {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3rem 2rem;
  border-radius: 2rem;
  min-height: 30vh;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: scroll;
}
.PayBills_history__HkVcf::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.PayBills_history__HkVcf::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.PayBills_history__top__TyRk8 {
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media only screen and (max-width: 37.5em) {
  .PayBills_history__top__TyRk8 {
    flex-direction: column;
  }
}
.PayBills_history__top__TyRk8 > :not(:last-child) {
  margin-right: 3rem;
}
@media only screen and (max-width: 37.5em) {
  .PayBills_history__top__TyRk8 > :not(:last-child) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
}
.PayBills_history__date__F8LxP {
  background: var(--color-dark);
  border-radius: 1rem;
  width: 12.5rem;
  padding: 1rem;
  text-align: center;
  margin: 0 0 2rem 2rem;
  font-weight: 700;
  font-size: var(--default-font-small);
  line-height: 1.7rem;
  color: var(--color-white);
}

.PayBills_table__bgZHe {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
  overflow-x: scroll;
  overflow-y: scroll;
}
.PayBills_table__bgZHe tr {
  padding: 0 2rem;
}
@media only screen and (max-width: 37.5em) {
  .PayBills_table__bgZHe tr {
    padding: 0 1.5rem;
  }
}
.PayBills_table__bgZHe tr img {
  width: 4.5rem;
  border-radius: 4.5rem;
}
.PayBills_table__bgZHe th,
.PayBills_table__bgZHe td {
  padding: 1rem;
}
.PayBills_table__bgZHe th {
  font-weight: 700;
}
.PayBills_table__bgZHe td {
  cursor: pointer;
}
.PayBills_table__bgZHe tbody tr {
  background-color: var(--color-grey-3);
}
.PayBills_table__bgZHe tbody tr:nth-child(even) {
  background-color: var(--color-light);
}
.PayBills_table__icon__9XCsF {
  width: 4.5rem;
  border-radius: 4.5rem;
}
@media only screen and (max-width: 37.5em) {
  .PayBills_table__icon__9XCsF {
    width: 2.5rem;
  }
}
.PayBills_table__title__0iZvb {
  color: var(--color-primary);
}
.PayBills_table__amount__QcBuf {
  color: var(--color-error);
}

.PayBills_pin__label__\\+s2P1 {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 4rem;
}
.PayBills_pin__item__B6JGO {
  margin-left: 2rem;
}

.PayBills_success__-zUY8 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PayBills_summary__iTMuk {
  text-align: start;
  width: 38rem;
}

.PayBills_error__yrYKS {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PayBills/PayBills.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AADD;AAGC;EAND;IAOE,2BAAA;IACA,aAAA;EAAA;AACF;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;AAAD;AACC;EACC,mBAAA;AACF;AAEC;EARD;IASE,mBAAA;EACA;AACF;AACC;EACC,wCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EAXD;IAYE,UAAA;EAED;AACF;AAAE;EAfD;IAgBE,aAAA;EAGD;AACF;AAFE;EAlBD;IAmBE,aAAA;EAKD;AACF;AAFC;EACC,WAAA;EACA,qBAAA;AAIF;AAFE;EAJD;IAKE,WAAA;EAKD;AACF;AAJE;EAPD;IAQE,WAAA;EAOD;AACF;;AAHA;EACC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAMD;AAJC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAMF;AAHC;EACC,mCAAA;EACA,mBAAA;AAKF;AAFC;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIF;AAHE;EALD;IAME,sBAAA;EAMD;AACF;AAJE;EACC,kBAAA;AAMH;AALG;EAFD;IAGE,eAAA;IACA,mBAAA;EAQF;AACF;AAJC;EACC,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;AAMF;;AAAA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AAGD;AADC;EAEC,eAAA;AAEF;AADE;EAHD;IAIE,iBAAA;EAID;AACF;AAYE;EACC,aAAA;EACA,qBAAA;AAVH;AAcC;;EAEC,aAAA;AAZF;AAeC;EACC,gBAAA;AAbF;AAgBC;EACC,eAAA;AAdF;AAkBE;EACC,qCAAA;AAhBH;AAkBG;EACC,oCAAA;AAhBJ;AAqBC;EACC,aAAA;EACA,qBAAA;AAnBF;AAqBE;EAJD;IAKE,aAAA;EAlBD;AACF;AAqBC;EACC,2BAAA;AAnBF;AAsBC;EACC,yBAAA;AApBF;;AA0BC;EACC,oCAAA;EACA,oBAAA;EACA,kBAAA;AAvBF;AA0BC;EACC,iBAAA;AAxBF;;AA4BA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAzBD;;AA4BA;EACC,iBAAA;EACA,YAAA;AAzBD;;AA4BA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAzBD","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 3fr;\n\tcolumn-gap: 3rem;\n\tmargin-top: 5rem;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 100%;\n\t\trow-gap: 3rem;\n\t}\n}\n\n.pb {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-evenly;\n\t& > :not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tflex-direction: row;\n\t}\n\n\t&__item {\n\t\tbackground-color: var(--color-primary-7);\n\t\twidth: 100%;\n\t\theight: 17rem;\n\t\tborder-radius: 2rem;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\twidth: 30%;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\theight: 12rem;\n\t\t}\n\t\t@media only screen and (max-width: $bp-400) {\n\t\t\theight: 10rem;\n\t\t}\n\t}\n\n\t&__image {\n\t\twidth: 6rem;\n\t\tmargin-bottom: 1.5rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\twidth: 4rem;\n\t\t}\n\t\t@media only screen and (max-width: $bp-400) {\n\t\t\twidth: 3rem;\n\t\t}\n\t}\n}\n\n.history {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3rem 2rem;\n\tborder-radius: 2rem;\n\tmin-height: 30vh;\n\theight: 80vh;\n\toverflow-y: scroll;\n\toverflow-x: scroll;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 3rem 3rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 3rem;\n\t}\n\n\t&__top {\n\t\tmargin-bottom: 2rem;\n\t\tdisplay: flex;\t\t\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__date {\n\t\tbackground: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\twidth: 12.5rem;\n\t\tpadding: 1rem;\n\t\ttext-align: center;\n\t\tmargin: 0 0 2rem 2rem;\n\t\tfont-weight: 700;\n\t\tfont-size: var(--default-font-small);\n\t\tline-height: 1.7rem;\n\t\tcolor: var(--color-white);\n\t}\n}\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\toverflow-x: scroll;\n\toverflow-y: scroll;\n\n\ttr {\n\t\t\n\t\tpadding: 0 2rem;\t\t\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tpadding: 0 1.5rem;\n\t\t}\n\n\t\t// & > :nth-child(1) {\n\t\t// \t@media only screen and (max-width: $bp-500) {\n\t\t// \t\tgrid-row: 1/3;\n\t\t// \t\tgrid-column: 1/2;\n\t\t// \t}\n\t\t// }\n\n\t\t// & > :nth-child(3) {\n\t\t// \t@media only screen and (max-width: $bp-500) {\n\t\t// \t\tgrid-row: 2/3;\n\t\t// \t\tgrid-column: 2/3;\n\t\t// \t}\n\t\t// }\n\n\t\timg {\n\t\t\twidth: 4.5rem;\n\t\t\tborder-radius: 4.5rem;\n\t\t}\n\t}\n\n\tth,\n\ttd {\n\t\tpadding: 1rem;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttd {\n\t\tcursor: pointer;\n\t}\n\n\ttbody {\n\t\ttr {\n\t\t\tbackground-color: var(--color-grey-3);\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-light);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__icon {\n\t\twidth: 4.5rem;\n\t\tborder-radius: 4.5rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\twidth: 2.5rem;\n\t\t}\n\t}\n\n\t&__title {\n\t\tcolor: var(--color-primary);\n\t}\n\n\t&__amount {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n//otpForm\n.pin {\n\t&__label {\n\t\tfont-size: var(--default-font-small);\n\t\tfont-family: inherit;\n\t\tpadding-left: 4rem;\n\t}\n\n\t&__item {\n\t\tmargin-left: 2rem;\n\t}\n}\n\n.success {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.summary {\n\ttext-align: start;\n\twidth: 38rem;\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PayBills_main__x4FDh`,
	"pb": `PayBills_pb__Gc2--`,
	"pb__item": `PayBills_pb__item__GIo4-`,
	"pb__image": `PayBills_pb__image__24Sfg`,
	"history": `PayBills_history__HkVcf`,
	"history__top": `PayBills_history__top__TyRk8`,
	"history__date": `PayBills_history__date__F8LxP`,
	"table": `PayBills_table__bgZHe`,
	"table__icon": `PayBills_table__icon__9XCsF`,
	"table__title": `PayBills_table__title__0iZvb`,
	"table__amount": `PayBills_table__amount__QcBuf`,
	"pin__label": `PayBills_pin__label__+s2P1`,
	"pin__item": `PayBills_pin__item__B6JGO`,
	"success": `PayBills_success__-zUY8`,
	"summary": `PayBills_summary__iTMuk`,
	"error": `PayBills_error__yrYKS`
};
export default ___CSS_LOADER_EXPORT___;
